import React from 'react';
import { useContent } from '../../../hooks/useContent';
import { conferenceEn } from '../../../content/conferenceEn';
import styles from './PastNewConference.module.css';

const CARD_IDS = ['card1', 'card2', 'card3', 'card4', 'card5', 'card6'];

const PastNewConference = () => {
  const { t } = useContent();
  const def = conferenceEn.pastNew;

  const registerUrl = t('conferencePastNew.registerButtonUrl', def.registerButtonUrl);
  const registerLabel = t('conferencePastNew.registerButtonLabel', def.registerButtonLabel);

  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <div className={styles.overlay} />
        <h1>{t('conferencePastNew.bannerTitle', def.bannerTitle)}</h1>
      </div>
      <h1 className={styles.title}>{t('conference.pastNew.pageTitle', def.pageTitle)}</h1>

      <div className={styles.grid}>
        {CARD_IDS.map((cid) => {
          const c = def.cards[cid] || {};
          return (
            <div key={cid} className={styles.card}>
              <h3 className={styles.cardTitle}>
                {t(`conferencePastNew.cards.${cid}.title`, c.title ?? '')}
              </h3>
              <p className={styles.cardDescription}>
                {t(`conferencePastNew.cards.${cid}.description`, c.description ?? '')}
              </p>
              <p className={styles.cardDate}>{t(`conferencePastNew.cards.${cid}.date`, c.date ?? '')}</p>
            </div>
          );
        })}
        <div className={styles.buttonContainer}>
          <a href={registerUrl} target="_blank" rel="noopener noreferrer">
            <button type="button" className={styles.registerButton}>
              {registerLabel}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PastNewConference;
